var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Center } from "core/components/Center";
import { Title } from "core/components/Grid";
import { Spinner } from "core/components/Spinner";
import { letterIndexVar } from "core/state";
import { colors } from "core/styles/snippets";
import { Tracking } from "core/tracking";
import { Id, content } from "core/utils";
import { UserInput } from "pages/programs/UserInput";
import { ProgramOverviewGrid } from "pages/programs/components/ProgramOverviewGrid/ProgramOverviewGrid";
import { OverviewItem } from "pages/programs/utils";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
export var SearchResults = function (_a) {
    var userInput = _a.userInput, queryResult = _a.queryResult;
    var ref = useRef(null);
    var hideResults = UserInput.isResultsHidden(userInput);
    var data = queryResult.data, error = queryResult.error, loading = queryResult.loading;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var items = [];
    useEffect(function () {
        if (items && userInput.text)
            Tracking.trackSearchInfo("view_program_overview_search_results", userInput.text, items.length, {
                channel: userInput.channel.current,
                category: userInput.category,
                letter: userInput.letter,
            });
    }, [items, hideResults]);
    if (loading) {
        return (React.createElement(Container, { ref: ref },
            React.createElement(Center, null,
                React.createElement(Spinner, null))));
    }
    if (error || !data || hideResults) {
        return null;
    }
    if (data.getFilteredOverviewItems === null)
        return null;
    if (data.getFilteredOverviewItems.items.length <= 0)
        return (React.createElement(Container, { ref: ref },
            React.createElement(Center, null,
                React.createElement(NoResults, null, content.programsPage.search.noResults))));
    if (data.letterInfos !== null) {
        letterIndexVar(data.letterInfos.letterInfo);
    }
    return (React.createElement(Container, { ref: ref },
        React.createElement(ProgramOverviewGrid, { containerRef: ref, title: content.title.programSearchResults, "data-component": Id.component.programSearchResultsGrid, items: OverviewItem.toContentItems(data.getFilteredOverviewItems.items), listName: "program-search-results" })));
};
var Container = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n"], ["\n  margin: 0;\n  padding: 0;\n"])));
var NoResults = styled(Title)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  color: ", ";\n"], ["\n  text-align: center;\n  color: ", ";\n"])), colors.black);
var templateObject_1, templateObject_2;
